module.exports = __webpack_public_path__ + "static/media/redux-full-socket.59c46753.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/redux-full-socket.png
// module id = 35
// module chunks = 0